import { Component } from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Contains render errors inside a panel so a fault can never blank the whole app.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="flex items-start gap-3 p-4 bg-rose-50 border border-rose-200 rounded-md text-rose-700"
          data-testid="error-boundary-fallback"
        >
          <AlertTriangle className="w-5 h-5 mt-0.5 shrink-0" />
          <div>
            <p className="font-semibold text-sm">{this.props.title || 'Something went wrong'}</p>
            <p className="text-xs mt-1">
              This panel failed to render. The rest of the application is unaffected — close and try again.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
